import { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../actions";

import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, showContaimerLoader, isPhone, removeChar, hasPermission } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
const module = "branch";
const modulePath = "/branch";
const moduleName = "Branch";
const moduleID = 18;
class Form extends Component {
  constructor(props) {
    super(props);
    const editID = this.props.location.state?.editID ?? "";
    this.state = {
      editID,
      postdata: {
        companyName: "",
        branchName: "",
        branchAddress: "",
        branchGSTNumber: "",
        branchContactPerson: "",
        branchContactPhone: "",
        branchStatus: "",
      },
      detaildata: [],
      error_msg: "",
      pageloading: false,
    };
  }

  componentDidMount() {
    if (this.state.editID !== "") {
      if (!hasPermission(moduleID, "edit")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
      const params = {
        params: "",
        url: `${module}/detail/${this.state.editID}`,
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    } else {
      if (!hasPermission(moduleID, "add")) {
        if (hasPermission(moduleID, "view")) {
          this.props.history.push(modulePath);
        } else {
          this.props.history.push("/search");
        }
      }
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.detaildata !== nextProps.detaildata && nextProps.detaildata !== "" && this.state.editID !== "") {
      this.setState({ detaildata: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          const result = nextProps.detaildata[0].result;

          const branchStatus = result.branchStatus === "A" ? "Active" : "In Active";
          const status =
            result.branchStatus !== "" && result.branchStatus !== null
              ? {
                  label: branchStatus,
                  value: result.branchStatus,
                }
              : "";
          const clientupdatedata = {
            companyName: result.companyName,
            branchName: result.branchName,
            branchAddress: result.branchAddress,
            branchGSTNumber: result.branchGSTNumber,
            branchContactPerson: result.branchContactPerson,
            branchContactPhone: result.branchContactPhone,
            branchStatus: status,
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid" + moduleName, "error");
        }
      });
    }
  }
  sateValChange = (field, value) => {};

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    const postData = this.state.postdata;

    const postObject = {
      companyName: postData.companyName.toUpperCase(),
      branchName: postData.branchName.toUpperCase(),
      branchAddress: postData.branchAddress.toUpperCase(),
      branchGSTNumber: postData.branchGSTNumber.toUpperCase(),
      branchContactPerson: postData.branchContactPerson.toUpperCase(),
      branchContactPhone: postData.branchContactPhone,
      branchStatus: postData.branchStatus?.value ?? "I",
    };

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, method);
  };

  render() {
    return (
      <div>
        <div className="page">
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid  mx-3">
                  <div className="page-header">
                    <h1 className="page-title">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h1>
                    <div>
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to={modulePath}>
                            <i className="fa fa-arrow-left me-1"></i>
                            GoBack
                          </Link>
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div className="row" id="modulefrm">
                    <div className="col-md-12 col-xl-12">
                      <div className="card">
                        {this.state.pageloading ? (
                          showContaimerLoader()
                        ) : (
                          <PostForm
                            {...this.props}
                            fields={this.state.postdata}
                            onChange={this.fieldChange}
                            onValid={this.handleSubmit}
                            editID={this.state.editID}
                            error_msg={this.state.error_msg}
                            onInvalid={() => {
                              console.log("Form invalid!");
                              setTimeout(function () {
                                if ($("#modulefrm .error").length > 0) {
                                  $("html, body").animate(
                                    {
                                      scrollTop: $(document).find("#modulefrm .error:first").offset().top - 100,
                                    },
                                    500,
                                  );
                                }
                              }, 500);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { companyName, branchName, branchAddress, branchGSTNumber, branchContactPhone, branchStatus } = props.fields;

  return {
    fields: ["companyName", "branchName", "branchAddress", "branchGSTNumber", "branchContactPhone", "branchStatus"],
    validations: {
      companyName: [[isEmpty, companyName]],
      branchName: [[isEmpty, branchName]],
      branchAddress: [[isEmpty, branchAddress]],
      branchGSTNumber: [[isEmpty, branchGSTNumber]],
      branchContactPhone: [[isPhone, branchContactPhone]],
      branchStatus: [[isSingleSelect, branchStatus]],
    },
  };
}

class PostForm extends Component {
  goBack() {
    this.props.history.push(modulePath);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handlecheckedChange(name, e) {
    this.props.onChange(name, e.target.checked);
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgcompanyName,
      errMsgbranchName,
      errMsgbranchAddress,
      errMsgbranchGSTNumber,
      errMsgbranchContactPhone,
      errMsgStatus = "";
    if ($validation.companyName.error.reason !== undefined) {
      errMsgcompanyName = $validation.companyName.show && <span className="error">{$validation.companyName.error.reason}</span>;
    }
    if ($validation.branchName.error.reason !== undefined) {
      errMsgbranchName = $validation.branchName.show && <span className="error">{$validation.branchName.error.reason}</span>;
    }
    if ($validation.branchAddress.error.reason !== undefined) {
      errMsgbranchAddress = $validation.branchAddress.show && <span className="error">{$validation.branchAddress.error.reason}</span>;
    }
    if ($validation.branchGSTNumber.error.reason !== undefined) {
      errMsgbranchGSTNumber = $validation.branchGSTNumber.show && <span className="error">{$validation.branchGSTNumber.error.reason}</span>;
    }
    if ($validation.branchStatus.error.reason !== undefined) {
      errMsgStatus = $validation.branchStatus.show && <span className="error">{$validation.branchStatus.error.reason}</span>;
    }
    if ($validation.branchContactPhone.error.reason !== undefined) {
      errMsgbranchContactPhone = $validation.branchContactPhone.show && <span className="error">{$validation.branchContactPhone.error.reason}</span>;
    }

    return (
      <div>
        <div className="card-body">
          <div className="form-row">
            <div className="form-group col-md-3">
              <label className="form-label">
                Company Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Company Name"
                name="companyName"
                value={fields.companyName}
                {...$field("companyName", (e) => onChange("companyName", e.target.value))}
              />
              {errMsgcompanyName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Branch Name<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Branch Name"
                name="branchName"
                value={fields.branchName}
                {...$field("branchName", (e) => onChange("branchName", e.target.value))}
              />
              {errMsgbranchName}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                Address<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Address"
                name="branchAddress"
                value={fields.branchAddress}
                {...$field("branchAddress", (e) => onChange("branchAddress", e.target.value))}
              />
              {errMsgbranchAddress}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">
                GST Number<span className="lbl-error">*</span>
              </label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="GST Number"
                name="branchGSTNumber"
                value={fields.branchGSTNumber}
                {...$field("branchGSTNumber", (e) => onChange("branchGSTNumber", e.target.value))}
              />
              {errMsgbranchGSTNumber}
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Contact Person</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Contact Person"
                name="branchContactPerson"
                value={fields.branchContactPerson}
                {...$field("branchContactPerson", (e) => onChange("branchContactPerson", e.target.value))}
              />
            </div>
            <div className="form-group col-md-3">
              <label className="form-label">Contact Phone</label>
              <input
                type="text"
                className="form-control upper-case"
                placeholder="Contact Phone"
                name="branchContactPhone"
                value={fields.branchContactPhone}
                {...$field("branchContactPhone", (e) => onChange("branchContactPhone", e.target.value))}
              />
              {errMsgbranchContactPhone}
            </div>
            <div className="form-group col-md-2">
              <label className="form-label">
                Status<span className="lbl-error">*</span>
              </label>
              <Select
                value={fields.branchStatus}
                onChange={this.handleSelectChange.bind(this, "branchStatus")}
                placeholder="Select Status"
                isClearable={true}
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
              />
              {errMsgStatus}
            </div>
          </div>
        </div>
        <div className="card-footer">
          <div className="btn-toolbar sw-toolbar sw-toolbar-bottom justify-content-end">
            <div className="btn-group me-2 sw-btn-group-extra submit_frm" role="group">
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  e.preventDefault();
                  this.props.$submit(onValid, onInvalid);
                }}
              >
                {this.props.editID !== "" ? "Update" : "Add New"}
              </button>

              <button className="btn btn-secondary" onClick={this.goBack.bind(this)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
